module.exports = __webpack_public_path__ + "img/59exp.1a620671.jpg";